import { useMediaQuery, useTheme } from '@mui/material'

import { BillingPlans } from './billing-plans.component'
import { BillingPlanMobile } from './billing-plan-mobile.component'
import { BillingTransactions } from './billing-transactions'
import { useAccountPaymentRedirect } from 'src/hooks'

import { useStyles } from './styles'
import { BillingCancellation } from './billing-cancellation.component'
import { EAccountSubscriptionPlans } from 'src/types'

interface IAccountBillingProps {
  subscriptionPlan?: EAccountSubscriptionPlans
}

const AccountBilling = ({ subscriptionPlan }: IAccountBillingProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  useAccountPaymentRedirect()

  return (
    <>
      <div className={classes.tabWrapper}>
        {isTablet ? <BillingPlanMobile /> : <BillingPlans />}
        {/* <SettingsPaymentMethods /> */}
        {subscriptionPlan !== EAccountSubscriptionPlans.enterprise && (
          <>
            <BillingTransactions />
            <BillingCancellation />
          </>
        )}
      </div>
    </>
  )
}

export { AccountBilling }
